type MissingTranslationReporterParams = {
  isTextAvailable: (namespace: string, key: string) => boolean;
  log?: (message: string) => void;
};

// Logs every missing translation key once per page load, so missing texts stay visible although the app fills them from the files shipped with the build.
export const createMissingTranslationReporter = ({
  isTextAvailable,
  // eslint-disable-next-line no-console
  log = console.warn,
}: MissingTranslationReporterParams) => {
  const reportedKeys = new Set<string>();

  return (languageCode: string, namespace: string, key: string): void => {
    const keyId = `${namespace}:${key}`;
    if (reportedKeys.has(keyId)) return;
    reportedKeys.add(keyId);

    const outcome = isTextAvailable(namespace, key) ? "a text from the build is shown" : "no text found, the key name is shown";
    log(`[i18n] Missing translation ${keyId} (${languageCode}): not in Crowdin, ${outcome}.`);
  };
};
